import * as actionTypes from '../../actions/action-types.js'
const initialState = {
    lastFetch: 0,
    loading: false,
}
const feeds = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.FD_FEEDS_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                data: action.data,
            }
        case actionTypes.FD_FEEDS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.FD_FEEDS_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.FD_FEEDS_REQUEST_CACHE:
            return state
        default: {
            return state
        }
    }
}

export default feeds
